import { cn } from '@/lib/utils';
import React, { useEffect, useState } from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 37
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  const Box = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-158" data-mp="39ipy2i59oumy">
      <div key={value} className="bg-[#D32F2F] text-white rounded-xl px-3 py-2 min-w-[64px] text-center shadow-md tabular-nums animate-fade-in" data-id="element-159" data-mp="34kwp5hckxmiz">
        {format(value)}
      </div>
      <span className="text-xs text-current opacity-70 mt-1 uppercase tracking-wider font-sans font-semibold" data-id="element-160" data-mp="30lfgyg5rqba4">
        {label}
      </span>
    </div>;
  return <div className="inline-flex items-center justify-center gap-2 text-2xl md:text-4xl font-display font-bold my-4" data-id="element-161" data-mp="2qm6s21prfmum">
      <Box value={timeLeft.hours} label="hs" data-id="element-162" data-mp="2lsvlm1ov1838" />
      <span className="text-[#D32F2F] pb-5" data-id="element-163" data-mp="2gv2en6fqga1w">:</span>
      <Box value={timeLeft.minutes} label="min" data-id="element-164" data-mp="2gvvbnfow3l6u" />
      <span className="text-[#D32F2F] pb-5" data-id="element-165" data-mp="2cu0emndzrtyv">:</span>
      <Box value={timeLeft.seconds} label="seg" data-id="element-166" data-mp="2cvbeic4bghkp" />
    </div>;
}
export function TrustBar({
  tone = 'light'
}: {
  tone?: 'light' | 'dark';
}) {
  return <div className={`flex flex-wrap justify-center gap-4 text-sm font-medium mt-4 ${tone === 'dark' ? 'text-gray-300' : 'text-brand-gray'}`} data-id="element-167" data-mp="22vu9zy0sw9qb">
      <div className="flex items-center gap-1.5" data-id="element-168" data-mp="1t6dnzjgr5ceu">
        <ShieldCheck className="w-4 h-4" data-id="element-169" data-mp="1y6ryr99qn0gk" /> Garantía 7 días
      </div>
      <div className="flex items-center gap-1.5" data-id="element-170" data-mp="1y4yprnbnk45e">
        <Lock className="w-4 h-4" data-id="element-171" data-mp="1jakg4ddza73e" /> Pago seguro
      </div>
      <div className="flex items-center gap-1.5" data-id="element-172" data-mp="1jc59hzok3jzo">
        <CreditCard className="w-4 h-4" data-id="element-173" data-mp="1o9x2kx0xtc5g" /> Mercado Pago
      </div>
    </div>;
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  variant = 'primary'
}: {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  variant?: 'primary' | 'success';
}) {
  const baseClass = 'w-full py-4 px-6 rounded-2xl font-display font-bold text-xl sm:text-[26px] text-white text-center transition-all flex justify-center items-center gap-2 hover:scale-[1.05] active:scale-[0.98] min-h-[80px] sm:min-h-[117px] animate-cta-pulse';
  const variants = {
    primary: 'bg-brand-green hover:bg-[#16a34a] shadow-[0_8px_20px_rgba(34,197,94,0.3)] border border-[#16a34a]/40',
    success: 'bg-brand-green hover:bg-[#16a34a] shadow-[0_8px_20px_rgba(34,197,94,0.3)] border border-[#16a34a]/40'
  };
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={cn(baseClass, variants[variant], className)} data-id="element-174" data-mp="xyv6ts7vaqhn">
        {children}
      </a>;
  }
  return <button onClick={onClick || (() => {
    document.getElementById('precios')?.scrollIntoView({
      behavior: 'smooth'
    });
  })} className={cn(baseClass, variants[variant], className)} data-id="element-175" data-mp="t0a67rope4so">
      {children}
    </button>;
}
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return;
}